export class oboeConfigModel {
    url!: string;
    method!: string;
    body?: any;
    cached: boolean | undefined;
    headers: { 'content-type': string, 'Authorization': string} = { 'content-type': 'application/json', Authorization: ''};

    getDefaultOboeModel(){
        return new oboeConfigModel(); 
    }
}